import { connect } from 'react-redux';
import { HeaderView } from './HeaderView';
import { getDropdownState } from '../../../data/dropdown-state';
import {
    viewInsuranceTab,
    viewPlanTab,
    viewBcbsTab,
    markTabChange,
} from '../../../data/dropdown-state/dropdownStateActions';
import { TAB } from '../../../constants';

export function mapStateToProps(state) {
    const dropdownState = getDropdownState(state);

    return {
        tab: dropdownState.tab,
        canSeeBcbs: dropdownState.canSeeBcbs,
        carrier: dropdownState.carrier,
        plan: dropdownState.plan,
        showSteps: !dropdownState.showSearch,
        showCarrierAndPlanHeader: !dropdownState.showSearch || dropdownState.tab === TAB.PLAN,
        tabChange: dropdownState.tabChange,
        planDisabled: dropdownState.planDisabled,
    };
}

export const mapDispatchToProps = {
    viewPlanTab,
    viewInsuranceTab,
    viewBcbsTab,
    markTabChange,
};

export const HeaderConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderView);
